"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SVBConsumerHeader", {
  enumerable: true,
  get: function get() {
    return _SVBConsumerHeader.default;
  }
});
var _SVBConsumerHeader = _interopRequireDefault(require("./src/SVBConsumerHeader"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }